import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

import {
  ROLE_QA_EXPERT,
  ROLE_SYSTEM_ADMIN,
} from '@/utils/const';

import { Validator } from 'vee-validate';
import moment from 'moment-timezone';

Validator.extend('max_words', (value, [max]) => {
  const words = value.split(' ').filter((el) => !!el).length;
  return words <= Number(max);
});

export default {
  components: {
    preloader,
  },
  props: ['conclusionData'],
  data () {
    return {
      // for tabs
      tabs: [
        // {
        //     'title': 'Very good translation',
        //     'name': 'verygood',
        //     'text': 'The translation fully meets the required quality level. It is appropriate in terms of both language and content and meets all customer-specific requirements. No error were found.',
        //     'class': 'conclusion-status conclusion-status_verygood',
        //     'active': true,
        // },
        {
          'title': 'Good translation',
          'name': 'good',
          'text': 'The translation fully meets the required quality level. It is appropriate in terms of both language and content and meets all customer-specific requirements. No error were found.',
          'class': 'conclusion-status conclusion-status_good',
          'active': true,
        }, {
          'title': 'Poor translation',
          'name': 'poor',
          'text': 'Overall, the translation meets the required quality level. However, the target text contains numerous minor errors which do not have a significant impatc on the comprehension of the text.',
          'class': 'conclusion-status conclusion-status_poor',
          'active': false,
        },
        // {
        //     'title': 'Very poor translation',
        //     'name': 'verypoor',
        //     'text': 'Overall, the translation meets the required quality level. However, the target text contains numerous minor errors which do not have a significant impatc on the comprehension of the text.',
        //     'class': 'conclusion-status conclusion-status_verypoor',
        //     'active': false,
        // },
        {
          'title': 'Incorrect translation',
          'name': 'incorrect',
          'text': 'The translation cannot meet the required quality level. The target text contains numerous minor errors which, taken as a whole, lead to a negative result.',
          'class': 'conclusion-status conclusion-status_incorrect',
          'active': false,
        },
      ],

      // store comments for this report
      conclusionComments: {},
      conclusion: null,

      sendData: {
        'ID': null,
        'ReportId': null,
        'ReportType': null,
        'ReportComment': null,
      },

      load: true,

    };
  },
  computed: {
    abilityChangeTab () {
      if (this.$store.getters.userRole === ROLE_QA_EXPERT ||
                this.$store.getters.userRole === ROLE_SYSTEM_ADMIN) {
        return true;
      }
      return false;
    },
    commentWordsNumber() {
      return this.sendData.ReportComment.split(' ').filter((el) => !!el).length;
    },
  },
  created () {
    this.conclusion = this.conclusionData;
    this.sendData.ReportId = this.conclusion.id;

    this.changeTab(this.conclusion.type);

    this.getComments();
  },
  methods: {

    /**
         * For show textarea
         *
         * @param {Number} index
         * @param {String} type
         */
    showElement (item, type) {
      item.showField = type;
      this.sendData.ReportComment = item.ReportComment;
    },

    /**
         * Method for change tab
         *
         * @param {String} name
         */
    changeTab (name) {
      this.sendData.ReportType = name;

      this.tabs.forEach((item, index) => {
        if (item.name == name) {
          this.tabs[index].active = true;
        } else {
          this.tabs[index].active = false;
        }
      });
    },

    /**
         * Method for get comment
         */
    getComments () {
      Api.reports
        .getReportsComments(this.conclusionData.id)
        .then((data) => {
          if (data.status == 200) {
            this.conclusionComments = data.data.map((el) => {
              el.time = el.TimeStamp && el.TimeStamp > 0
                ? moment.unix(el.TimeStamp).format('DD.MM.YYYY hh:mm [GMT] +1.00')
                : 'No date info';
              return el;
            });
            this.holderData();
          }
          this.load = false;
        });
    },

    /**
         * Holder gettings data
         *
         * @param {Array} data
         */
    holderData () {
      this.conclusionComments.forEach((item, key) => {
        if (this.conclusion.user.UserId == item.UserID) {
          this.sendData.ID = item.ID;
          this.$set(item, 'active', true);
          this.$set(item, 'showField', true);

          if (item.ReportComment !== null) {
            item.showField = false;
          } else {
            item.showField = true;
          }
        }
      });
    },

    /**
         * Method for update comment
         */
    async updateComments () {
      const valid = await this.$validator.validate();
      if (!valid) {
        return;
      }
      Api.reports
        .updateReportsComments(this.sendData)
        .then((data) => {
          if (data.data.Status) {
            this.getComments();

            const newData = this.$store.getters.getDataSendCustomer;
            newData.ReportType = this.sendData.ReportType;
            this.$store.dispatch('REPORTS_DATA_CUSTOMER_UPDATE', newData);

            this.$root.$emit('notification', {
              message: 'Update successful',
              type: 'info',
              show: true,
            });
          }
        });
    },

    removeComment () {
      this.load = true;

      Api.reports.comments
        .removeReportsComments(this.sendData)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'info',
              show: true,
            });

            this.$emit('refresh');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
          this.load = false;
        });
    },
  },
};
